import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { Spinner } from '@gs/fe-storybook-gasco';
import { isTokenValid, login } from '../../config/services/auth/authConfig';
import OnboardingModal from '../../components/onboarding/onboarding-modal/OnboardingModal';
import WelcomeImg from '../../assets/images/welcome.svg';
import './welcome.css';

const Welcome = () => {
  const navigate = useNavigate();
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [errorMessage, setErrorMessage] = useState<string | null>(null);

  useEffect(() => {
    const token = localStorage.getItem('accessToken');
    if (token && isTokenValid(token)) {
      navigate('/validation');
    }
  }, [navigate]);

  const handleClick = async () => {
    setIsLoading(true);
    setErrorMessage(null);
    try {
      const username = process.env.REACT_APP_USERNAME!;
      const password = process.env.REACT_APP_PASSWORD!;
      const response = await login(username, password);

      if (response.metadata.statusCode === '200') {
        localStorage.setItem('accessToken', response.data.accessToken);
        setIsModalVisible(true);
      } else {
        alert('Error: ' + response.metadata.statusMessage);
      }
    } catch (error) {
      setErrorMessage('Error en el login. Verifica las credenciales.');
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <>
      <div className="welcome-container" id="page-welcome" data-page-id="bienvenida">
        <p className="title">Bienvenido a</p>
        <p className="principal-title">
          <span className="gasco">Gasco</span>
          <span className="pass">Pass</span>
        </p>
        <p className="subtitle">La forma más segura de validar tu identidad</p>
        <img
          className="welcomeImg"
          src={WelcomeImg}
          alt="Bienvenido a GascoPass"
        />
        {errorMessage && (
          <div className="error-message2">
            <p>{errorMessage}</p>
          </div>
        )}
        {isLoading ? (
          <div className="spinner-container">
            <Spinner size="large" />
          </div>
        ) : (
          <button id="bienvenida_" className="bienvenidaButton" onClick={handleClick}>
            Continuar
          </button>
        )}

        <OnboardingModal
          isVisible={isModalVisible}
          onClose={() => setIsModalVisible(false)}
        />
      </div>
    </>
  );
};

export default Welcome;
